
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 110 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#533AFD","fill-rule":"evenodd","d":"M101.2 25.473c0-6.513-3.183-11.653-9.266-11.653-6.108 0-9.804 5.14-9.804 11.603 0 7.658 4.363 11.525 10.626 11.525 3.054 0 5.364-.687 7.11-1.653v-5.09c-1.746.866-3.748 1.4-6.289 1.4-2.49 0-4.697-.865-4.98-3.867h12.552c0-.33.051-1.654.051-2.265m-12.68-2.417c0-2.875 1.772-4.07 3.389-4.07 1.565 0 3.234 1.195 3.234 4.07zM72.222 13.82c-2.515 0-4.132 1.17-5.03 1.985l-.334-1.578h-5.647v29.668l6.417-1.349.026-7.2c.924.661 2.284 1.602 4.543 1.602 4.594 0 8.778-3.663 8.778-11.729-.026-7.379-4.261-11.399-8.753-11.399m-1.54 17.53c-1.514 0-2.412-.533-3.028-1.195l-.026-9.44c.667-.737 1.591-1.246 3.054-1.246 2.336 0 3.953 2.595 3.953 5.928 0 3.41-1.591 5.954-3.953 5.954M52.382 12.319l6.442-1.374V5.78l-6.442 1.348z","clip-rule":"evenodd"}}),_c('path',{attrs:{"fill":"#533AFD","d":"M58.824 14.252h-6.442v22.264h6.442z"}}),_c('path',{attrs:{"fill":"#533AFD","fill-rule":"evenodd","d":"m45.478 16.136-.411-1.883h-5.544v22.263h6.417V21.428c1.514-1.96 4.08-1.603 4.876-1.323v-5.852c-.821-.306-3.824-.865-5.338 1.883M32.644 8.731l-6.262 1.323-.026 20.38c0 3.766 2.849 6.54 6.648 6.54 2.104 0 3.644-.382 4.491-.84v-5.165c-.821.33-4.876 1.5-4.876-2.265v-9.032h4.876v-5.42H32.62zM15.294 20.716c0-.993.821-1.375 2.181-1.375 1.951 0 4.415.586 6.366 1.629v-5.98c-2.13-.839-4.235-1.17-6.366-1.17-5.21 0-8.675 2.697-8.675 7.2 0 7.023 9.753 5.904 9.753 8.932 0 1.17-1.026 1.551-2.464 1.551-2.13 0-4.85-.864-7.007-2.035v6.056a17.9 17.9 0 0 0 7.007 1.45c5.339 0 9.01-2.62 9.01-7.175-.026-7.582-9.805-6.234-9.805-9.083","clip-rule":"evenodd"}})])
          )
        }
      }
    